<form nz-form [formGroup]="userSettingForm" (ngSubmit)="submitForm(userSettingForm.value)" class="pb-4">
  <div nz-row>
    <div nz-col nzSpan="24">
      <nz-form-label nzRequired><b>Thanh Menu</b></nz-form-label>
      <nz-form-item>
        <nz-form-control>
          <nz-radio-group formControlName="positionMenuNav">
            <label nz-radio nzValue="left">Bên trái</label>
            <label nz-radio nzValue="top">Trên cùng</label>
          </nz-radio-group>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSpan="24">
      <nz-form-label nzRequired><b>Nút chức năng</b></nz-form-label>
      <div nz-row>
        <nz-form-item nz-col nzSpan="24">
          <nz-form-control>
            <nz-radio-group formControlName="btnType" nz-col nzSpan="24">
              <div nz-row class="flex items-center mt-2">
                <div nz-col nzSm="12" nzMd="8" nzXl="8">
                  <label nz-radio [nzValue]="ButtonTypeEnum.ICON">Biểu tượng - Icon
                  </label>
                </div>
                <div nz-col nzSm="12" nzMd="16" nzXl="16">
                  <button class="flex items-center justify-center" nz-button nzTooltipTitle="Thêm"
                    nzTooltipPlacement="bottom" nz-tooltip type="button">
                    <i nz-icon nzType="user-add" nzTheme="outline">
                    </i>
                  </button>
                </div>
              </div>
              <div nz-row class="flex items-center mt-2">
                <div nz-col nzSm="12" nzMd="8" nzXl="8">
                  <label nz-radio [nzValue]="ButtonTypeEnum.TEXT">Tên nút</label>
                </div>
                <div nz-col nzSm="12" nzMd="16" nzXl="16">
                  <button class="flex items-center justify-center" nz-button type="button">Thêm
                  </button>
                </div>
              </div>
              <div nz-row class="flex items-center mt-2">
                <div nz-col nzSm="12" nzMd="8" nzXl="8">
                  <label nz-radio [nzValue]="ButtonTypeEnum.TEXTANDICON">Biểu tượng và Tên nút</label>
                </div>
                <div nz-col nzSm="12" nzMd="16" nzXl="16">
                  <button class="flex items-center justify-center" nz-button type="button">
                    <i nz-icon nzType="user-add" nzTheme="outline">
                    </i>Thêm
                  </button>
                </div>
              </div>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
  </div>
  <!-- <div nz-row>
    <div nz-col nzSpan="24" class="pr-1">
      <nz-form-item>
        <nz-form-label [nzSpan]="24" nzRequired><b>Ngôn ngữ</b></nz-form-label>
        <nz-form-control [nzSpan]="22" nzHasFeedback nzErrorTip="Chọn ngôn ngữ">
          <nz-select formControlName="ngonNgu" [nzCustomTemplate]="semesterTemplate">
            <nz-option nzValue="1" nzLabel="Tiếng Việt"></nz-option>
          </nz-select>
          <ng-template #semesterTemplate let-selected>
            <div class="ant-select-selection-item-content flex items-center">
              <i nz-icon nzType="tag" class="mr-2"></i>
              {{ selected.nzLabel }}
            </div>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div> -->
  <div class="drawer-footer">
    <button class="mr-2" nz-button (click)="close($event)">Đóng</button>
    <button class="mr-2" nz-button nzType="primary" type="submit">Cài đặt</button>
  </div>
</form>
